import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Button, CardBody, FormGroup } from "reactstrap";
import moment from "moment";
import { toast } from "react-toastify";
import APIClient from "../../helpers/APIClient";
import PageTitle from "../../components/PageTitle";
import Loader from "../../components/Loader";
import ModalPopup from "../../components/ModalPopup";
import { connect } from "react-redux";
import { baseUrl } from "../../constants/environment";
import styled from "styled-components";
import ReceiptsAdd from "../receipts/ReceiptsAdd";
import OrderAddCustomer from "./components/OrderAddCustomer";
import OrderAddInfo from "./components/OrderAddInfo";
import OrderAddProduct from "./components/OrderAddProduct";
import OrderAddPayment from "./components/OrderAddPayment";
import OrderAddShip from "./components/OrderAddShip";
import { changeSidebarType } from "../../redux/actions";
import ProductUtil from "../../helpers/ProductUtil";
import { ReasonList, RenderActionModal, StatusList } from "./OrderList";
import OrderAddHistory from "./components/OrderAddHistory";
import IconOrderReason from "../../assets/images/icon-order-reason.png";
import { getAllByDisplayValue } from "@testing-library/react";
import TextUtils from "../../helpers/TextUtils";
import queryString from "query-string";
import { cloneDeep } from "lodash";
import MessageManager from "../../manager/MessageManager";
import PriceUtils from "../../helpers/PriceUtils";

interface Props {
  history: any;
  location: any;
  match: any;
  user: any;
  changeSidebarType: any;
}

const Detail: React.FC<Props> = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(props.match.params.id);
  const [onlyView, setOnlyView] = useState(false);
  const [data, setData] = useState<any>({
    discount_type: "price",
    shipping_status: true,
    branchF : props?.location?.state?.exam,
    branch_id: props.user?.branch_id?.id,
    shipping_address_type: "outer"
  });
  const searchPrams = queryString.parse(props.location.search);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [type, setType] = useState(props.match.params.action);
  const [action, setAction] = useState<any>();
  const [customers, setCustomers] = useState();
  const [orderSource, setOrderSource] = useState();
  const [shippingPartner, setShippingPartner] = useState();
  const [productTemplate, setProductTemplate] = useState<any>();
  const [product, setProduct] = useState<any>([]);
  const [history, setHistory] = useState<any>();
  const [branch, setBranch] = useState<any>([]);
  const [payment, setPayment] = useState<any>([
    {
      payment_method_id: "",
      payment_total: "",
    },
  ]);
  const [paymentSynce, setPaymentSynce] = useState<any>([]);
  const paymentSynceRef = useRef<any>(null);
  const [branch_ids , setBranchIds] = useState<any>();
  useEffect(() => {
    if (id && id !== "add") {
      loadData(id);
      document.title = "Chỉnh sửa đơn online";
    } else {
      document.title = "Tạo đơn online";
    }
    if (type === "view") {
      setOnlyView(true);
      loadHistory(id);
      document.title = "Chi tiết đơn online";
    }
  }, [id]);

  useEffect(() => {
    paymentSynceRef.current = paymentSynce
  }, [paymentSynce]);

  useEffect(() => {
    loadInit();
    // props.changeSidebarType(layoutConstants.LEFT_SIDEBAR_TYPE_CONDENSED);

    MessageManager.addListener({
      onUpdatePaymentStatusOrder,
    });
    return () => {
      MessageManager.removeListener("onUpdatePaymentStatusOrder");
    };
  }, []);

  const onUpdatePaymentStatusOrder = (dataPayment: any) => {
    const clonePaymentSynce:any = cloneDeep(paymentSynceRef?.current)
    const newPaymentSynce = clonePaymentSynce?.reduce((prev:any, item:any)=>{
      if(item?.id === dataPayment?.id){
        item.status = dataPayment?.status
        if(item.status === 1) toast.success(`Phiếu thu ${item?.code} vừa nhận được thanh toán: ${PriceUtils.format(item?.payment_total, ' đ')}`)
        if(item.status === -1) toast.success(`Phiếu thu ${item?.code} chuyển trạng thái thất bại`)
      }
      prev = [...prev, item]
      return prev
    },[])
    setPaymentSynce(newPaymentSynce)
  };

  useEffect(() => {
    if (searchPrams?.prescription_ids) {
      let prescription_ids: any = searchPrams?.prescription_ids;
      let arrayPrescription = prescription_ids.split(",");
      setData({
        ...data,
        prescription_ids: arrayPrescription,
      });
    }
  }, [searchPrams?.prescription_ids]);

  useEffect(() => {
    if (searchPrams?.prescription_id) {
      setData({
        ...data,
        prescription_id: searchPrams?.prescription_id,
      });
    }
  }, [searchPrams?.prescription_id]);

  useEffect(() => {
    if (data?.prescription_id && (!id || (id && id === "add"))) {
      loadDataByprescription(Number(data?.prescription_id));
    }
  }, [data?.prescription_id]);

  useEffect(() => {
    if (data?.prescription_ids && (!id || (id && id === "add"))) {
      loadDataByprescriptions(data?.prescription_ids);
    }
  }, [data?.prescription_ids]);

  const handleActionModal = (item: any) => {
    setAction(item);
    setIsOpen(true);
  };
  
  const loadDataByprescription = async (id: number) => {
    const url = `${baseUrl}/prescription/${id}`;
    setLoading(true);
    let response: any = await APIClient.GET(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData:any = response.response;
      const resDataProduct = resData?.prescription_products?.reduce(
        (prev: any, item: any) => {
          const product_units_lockup: any = {};
          product_units_lockup["root"] = {
            name: item?.product_id?.minimum_unit,
            quantity_conversion: 1,
          };
          item?.product_id?.product_units?.map((itemUnit: any) => {
            product_units_lockup[itemUnit?.quantity_conversion] = itemUnit;
          });
          const product_variants = item?.product_id?.product_variants;
          const product_variants_units: any = ProductUtil.parseProductUnit(
            item?.product_id,
            product_variants,
            product_units_lockup
          );
          //stock
          const product_stock_lockup:any = {}
          item?.product_id?.product_stock?.map((itemUnit:any)=>{
              if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root']) product_stock_lockup[itemUnit?.variant_id?.id || 'root'] = {}
              if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id]) product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id] = {}
              if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root']) product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root'] = {}
              product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root'] = Number(itemUnit?.quantity)
          })
          let itemRoot = {
            name: item?.product_id?.name,
            sku: item?.product_id?.sku,
            stock_max: item?.product_id?.stock_max,
            stock_min: item?.product_id?.stock_min,
            type: item?.product_id?.type,
            status: item?.product_id?.status,
            height: item?.product_id?.height,
            weight: item?.product_id?.weight,
            width: item?.product_id?.width,
            longs: item?.product_id?.longs,
            vat: item?.product_id?.vat,
            price: item?.product_id?.price,
            price_import: item?.product_id?.price_import,
            price_wholesale: item?.product_id?.price_wholesale,
            product_id: item?.product_id?.id,
            variant_id: null,
            value: `${item?.id}`,
            label: item?.product_id?.name,
            units: product_variants_units,
            avatar:
              item?.product_id?.product_images &&
              item?.product_id?.product_images[0] &&
              item?.product_id?.product_images[0]?.url,
            batchs: ProductUtil.parseProductBatch(
              item?.product_id?.product_batchs || []
            ),
            stock_quantity: product_stock_lockup,
            product_type: item?.product_id?.product_type
          };
          if (item?.variant_id) {
            const itemVariant = item?.variant_id;
            const product_variants_units: any = ProductUtil.parseProductUnit(
              itemVariant,
              product_variants,
              product_units_lockup
            );
            itemRoot = {
              ...itemRoot,
              name: itemVariant?.name,
              sku: itemVariant?.sku,
              vat: itemVariant?.vat,
              price: item?.price,
              price_import: itemVariant?.price_import,
              price_wholesale: itemVariant?.price_wholesale,
              product_id: item?.id,
              variant_id: itemVariant?.id,
              value: `${item?.id}-${itemVariant?.id}`,
              label: itemVariant?.name,
              units: product_variants_units,
              batchs: ProductUtil.parseProductBatch(
                itemVariant?.product_batchs || []
              ),
            };
          }
          prev = [
            ...prev,
            {
              id: item?.id,
              product_id: item?.product_id?.id,
              variant_id: item?.variant_id?.id,
              product: itemRoot,
              fundaccount_id : item?.fundaccount_id,
              quantity: item?.product_quantity,
              price: item?.product_price,
              price_request: item?.price_request,
              discount: item?.discount,
              discount_type: item?.discount_type,
              discount_value:
                item?.discount_type === "percent"
                  ? Number(item?.discount_value || 0) * 100
                  : Number(item?.discount_value || 0),
              unit_id: item?.unit_id?.id || 0,
              batch_id: item?.batch_id?.id || 0,
            },
          ];
          return prev;
        },
        []
      );
      let address_default = resData?.customer_id?.address?.filter((itemFil:any)=> itemFil?.status === 1)
      let shipping_address = ''
      if(address_default[0]) {
        address_default = address_default[0]
        shipping_address = address_default?.street || ""
        if(address_default?.wards_code?.name) shipping_address += ", " + address_default?.wards_code?.name
        if(address_default?.district_code?.name) shipping_address += ", " + address_default?.district_code?.name
        if(address_default?.provinces_code?.name) shipping_address += ", " + address_default?.provinces_code?.name
        resData.customer_id.address_default = address_default
      }
      const resDataExam = resData?.examination_id;
      if(resDataExam == null) {
        const dataTemp: any = {
          ...data,
          shipping_address,
          branch_id: resData.branch_id?.id,
          customer_id: resData?.customer_id,
          prescription_code: resData?.code,
          orderspackage: {
            ...resData?.orderspackage_id?.orderspackage_services?.[0],
            name: resData?.orderspackage_id?.orderspackage_services?.[0]?.name,
            orderspackage_id: resData?.orderspackage_id?.id,
            servicepackage_id: resData?.orderspackage_id?.orderspackage_services?.[0]?.servicepackage_id,
            service_package_id: resData?.orderspackage_id?.orderspackage_services?.[0]?.servicepackage_id?.id,
            value: resData?.orderspackage_id?.orderspackage_services?.[0]?.servicepackage_id?.id
          }
        };
        setProduct(resDataProduct);
        setData(dataTemp);
      } else if(resDataExam?.orderspackage_id !== '' && resDataExam?.service_package_id !== "") {
        const dataTemp: any = {
          ...data,
          shipping_address,
          branch_id: resData.branch_id?.id,
          customer_id: resData?.customer_id,
          prescription_code: resData?.code,
          orderspackage: {
            ...resDataExam?.orderspackage_id?.orderspackage_services?.[0],
            value: resDataExam?.service_package_id?.id,
            name: resDataExam?.service_package_id?.name,
            servicepackage_id: resDataExam?.service_package_id,
            orderspackage_id: resDataExam?.orderspackage_id?.id,
            service_package_id: resDataExam?.service_package_id?.id
          },
        };
        setProduct(resDataProduct);
        setData(dataTemp);
      }else {
        const dataTemp: any = {
          ...data,
          shipping_address,
          branch_id: resData.branch_id?.id,
          customer_id: resData?.customer_id,
          prescription_code: resData?.code,
        };
        setProduct(resDataProduct);
        setData(dataTemp);
      }
    }
  };
  
  const loadDataByprescriptions = async (ids: any) => {
    setLoading(true);
    let prescriptions_product_array: any = await Promise.all(
      ids.map((item: any) => {
        return APIClient.GET(`${baseUrl}/prescription/${item}`);
      })
    );
    setLoading(false);
    let resData_exam = prescriptions_product_array.map((item: any) => {
      return item?.response?.examination_id || [];
    });
    loadExam(resData_exam?.[0]?.id)
    let products = prescriptions_product_array.map((item: any) => {
      return item?.response?.prescription_products || [];
    });
    let prescriptions_product = products.reduce((prev: any, item: any) => {
      const prevItem = item?.reduce((prevProduct: any, itemProduct: any) => {
        //check có
        const indexProdCurrent = prev?.findIndex((itemFind: any) => {
          return itemFind?.product_id?.id === itemProduct?.product_id?.id;
        });
        if (indexProdCurrent !== -1) {
          //tăng số lượng lên
          prev[indexProdCurrent] = {
            ...prev[indexProdCurrent],
            product_quantity:
              prev[indexProdCurrent]?.product_quantity +
              itemProduct?.product_quantity,
          };
        } else {
          prevProduct = [...prevProduct, itemProduct];
        }
        return prevProduct;
      }, []);
      prev = [...prev, ...prevItem];
      return prev;
    }, []);

    const resDataProduct = prescriptions_product?.reduce(
      (prev: any, item: any) => {
        const product_units_lockup: any = {};
        product_units_lockup["root"] = {
          name: item?.product_id?.minimum_unit,
          quantity_conversion: 1,
        };
        item?.product_id?.product_units?.map((itemUnit: any) => {
          product_units_lockup[itemUnit?.quantity_conversion] = itemUnit;
        });
        const product_variants = item?.product_id?.product_variants;
        const product_variants_units: any = ProductUtil.parseProductUnit(
          item?.product_id,
          product_variants,
          product_units_lockup
        );
        //stock
        const product_stock_lockup:any = {}
        item?.product_id?.product_stock?.map((itemUnit:any)=>{
            if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root']) product_stock_lockup[itemUnit?.variant_id?.id || 'root'] = {}
            if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id]) product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id] = {}
            if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root']) product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root'] = {}
            product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root'] = Number(itemUnit?.quantity)
        })
        let itemRoot = {
          name: item?.product_id?.name,
          sku: item?.product_id?.sku,
          stock_max: item?.product_id?.stock_max,
          stock_min: item?.product_id?.stock_min,
          type: item?.product_id?.type,
          status: item?.product_id?.status,
          height: item?.product_id?.height,
          weight: item?.product_id?.weight,
          width: item?.product_id?.width,
          longs: item?.product_id?.longs,
          vat: item?.product_id?.vat,
          price: item?.product_id?.price,
          price_import: item?.product_id?.price_import,
          price_wholesale: item?.product_id?.price_wholesale,
          product_id: item?.product_id?.id,
          variant_id: null,
          value: `${item?.id}`,
          label: item?.product_id?.name,
          units: product_variants_units,
          avatar:
            item?.product_id?.product_images &&
            item?.product_id?.product_images[0] &&
            item?.product_id?.product_images[0]?.url,
          batchs: ProductUtil.parseProductBatch(
            item?.product_id?.product_batchs || []
          ),
          stock_quantity: product_stock_lockup,
          product_type: item?.product_id?.product_type
        };
        if (item?.variant_id) {
          const itemVariant = item?.variant_id;
          const product_variants_units: any = ProductUtil.parseProductUnit(
            itemVariant,
            product_variants,
            product_units_lockup
          );
          itemRoot = {
            ...itemRoot,
            name: itemVariant?.name,
            sku: itemVariant?.sku,
            vat: itemVariant?.vat,
            price: item?.price,
            price_import: itemVariant?.price_import,
            price_wholesale: itemVariant?.price_wholesale,
            product_id: item?.id,
            variant_id: itemVariant?.id,
            value: `${item?.id}-${itemVariant?.id}`,
            label: itemVariant?.name,
            units: product_variants_units,
            batchs: ProductUtil.parseProductBatch(
              itemVariant?.product_batchs || []
            ),
          };
        }
        prev = [
          ...prev,
          {
            id: item?.id,
            product_id: item?.product_id?.id,
            variant_id: item?.variant_id?.id,
            fundaccount_id : item?.fundaccount_id,
            product: itemRoot,
            quantity: item?.product_quantity,
            price: item?.product_price,
            price_request: item?.price_request,
            discount: item?.discount,
            discount_type: item?.discount_type,
            discount_value:
              item?.discount_type === "percent"
                ? Number(item?.discount_value || 0) * 100
                : Number(item?.discount_value || 0),
            unit_id: item?.unit_id?.id || 0,
            batch_id: item?.batch_id?.id || 0,
          },
        ];
        return prev;
      },
      []
    );
    const customer_id = prescriptions_product_array?.[0]?.response?.customer_id
    let address_default = customer_id?.address?.filter((itemFil:any)=> itemFil?.status === 1)
    let shipping_address = ''
    if(address_default[0]) {
      address_default = address_default[0]
      shipping_address = address_default?.street || ""
      if(address_default?.wards_code?.name) shipping_address += ", " + address_default?.wards_code?.name
      if(address_default?.district_code?.name) shipping_address += ", " + address_default?.district_code?.name
      if(address_default?.provinces_code?.name) shipping_address += ", " + address_default?.provinces_code?.name
      customer_id.address_default = address_default
    }
    if(resData_exam?.[0]?.orderspackage_id !== '' && resData_exam?.[0]?.service_package_id !== "") {
      const dataTemp: any = {
        ...data,
        shipping_address,
        customer_id: customer_id,
        orderspackage: {
          ...resData_exam?.[0]?.orderspackage_id?.orderspackage_services?.[0],
          value: resData_exam?.[0]?.service_package_id?.id,
          name: resData_exam?.[0]?.service_package_id?.name,
          servicepackage_id: resData_exam?.[0]?.service_package_id,
          orderspackage_id: resData_exam?.[0]?.orderspackage_id?.id,
          service_package_id: resData_exam?.[0]?.service_package_id?.id
        },
        branch_id: prescriptions_product_array?.[0]?.response?.branch_id?.id
      //   prescription_code: resData?.code,
      };
      setData(dataTemp);
    }else {
      const dataTemp: any = {
        ...data,
        shipping_address,
        customer_id: customer_id,
        branch_id: prescriptions_product_array?.[0]?.response?.branch_id?.id
      //   prescription_code: resData?.code,
      };
      setData(dataTemp);
    }
    setProduct(resDataProduct);
  };

  const loadExam = async (idExam: number) => {
		const url = `${baseUrl}/examination/${idExam}`;
		setLoading(true);
		let response: any = await APIClient.GET(url);
		setLoading(false);
		if (response.error !== undefined) {
			toast.error(response.error.error_description);
		} else if (response.response !== undefined) {
			const resData = response.response;
      setBranchIds(resData?.branch_id?.id)
		}
	};
  
  const loadHistory = async (id: number) => {
    const url = `${baseUrl}/orders/history/${id}`;
    setLoading(true);
    let response: any = await APIClient.GET(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData = response.response?.data;
      setHistory(resData);
    }
  };

  const loadInit = async () => {
    const params = {
      status: 1,
      page: 1,
      limit: 5000,
    };
    const [
      responseCustomer,
      responseOrderSource,
      responseProductTemplate,
      responseShippingPartner,
      responseBranch,
    ] = await Promise.all([
      APIClient.GET(`${baseUrl}/customer`, params),
      APIClient.GET(`${baseUrl}/sales-channel`, params),
      APIClient.GET(`${baseUrl}/product`, {
        ...params,
        limit: 20,
        include_product_stock: true,
      }),
      APIClient.GET(`${baseUrl}/shipping-partner`, { ...params, limit: 200, activities: true }),
      APIClient.GET(`${baseUrl}/branch`, { ...params, limit: 200 }),
    ]);
    if (responseCustomer.response?.data !== undefined) {
      let ListArr: any = [];
      responseCustomer.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setCustomers(ListArr);
    }
    if (responseOrderSource.response?.data !== undefined) {
      let ListArr: any = [];
      responseOrderSource.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setOrderSource(ListArr);
    }
    if (responseProductTemplate.response?.data !== undefined) {
      const ListArr = ProductUtil.parseProduct(
        responseProductTemplate.response?.data
      );
      setProductTemplate(ListArr);
    }
    if (responseShippingPartner.response?.data !== undefined) {
      let ListArr: any = [{
        value: null,
        label: "Không chọn vận chuyển",
      }];
      responseShippingPartner.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setShippingPartner(ListArr);
    }
    if (responseBranch.response?.data !== undefined) {
      let ListArr: any = [];
      responseBranch.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setBranch(ListArr);
    }
    
  };

  const loadBranch = async (shipping_partner_id:number) => {
    const params = {
      status: 1,
      page: 1,
      limit: 3000,
      shipping_partner_id: shipping_partner_id
    };
    const [
      responseBranch,
    ] = await Promise.all([
      APIClient.GET(`${baseUrl}/branch`, { ...params, limit: 200 }),
    ]);
    if (responseBranch.response?.data !== undefined) {
      let ListArr: any = [];
      responseBranch.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setBranch(ListArr);
    }
    
  };

  const loadCustomers = async () => {
    const params = {
      status: 1,
      page: 1,
      limit: 3000,
    };
    const [responseCustomer] = await Promise.all([
      APIClient.GET(`${baseUrl}/customer`, params),
    ]);
    if (responseCustomer.response?.data !== undefined) {
      let ListArr: any = [];
      responseCustomer.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
      });
      setCustomers(ListArr);
    }
  };

  const loadData = async (id: number) => {
    const url = `${baseUrl}/orders/${id}`;
    setLoading(true);
    let response: any = await APIClient.GET(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData = response.response;
      const resDataProduct = resData?.orders_products?.reduce(
        (prev: any, item: any) => {
          const product_units_lockup: any = {};
          product_units_lockup["root"] = {
            name: item?.product_id?.minimum_unit,
            quantity_conversion: 1,
          };
          item?.product_id?.product_units?.map((itemUnit: any) => {
            product_units_lockup[itemUnit?.quantity_conversion] = itemUnit;
          });
          const product_variants = item?.product_id?.product_variants;
          const product_variants_units: any = ProductUtil.parseProductUnit(
            item?.product_id,
            product_variants,
            product_units_lockup
          );
          //stock
          const product_stock_lockup:any = {}
          item?.product_id?.product_stock?.map((itemUnit:any)=>{
              if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root']) product_stock_lockup[itemUnit?.variant_id?.id || 'root'] = {}
              if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id]) product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id] = {}
              if(!product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root']) product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root'] = {}
              product_stock_lockup[itemUnit?.variant_id?.id || 'root'][itemUnit?.branch_id?.id][itemUnit?.batch_id?.id || 'root'] = Number(itemUnit?.quantity)
          })
          let itemRoot = {
            name: item?.product_id?.name,
            sku: item?.product_id?.sku,
            stock_max: item?.product_id?.stock_max,
            stock_min: item?.product_id?.stock_min,
            type: item?.product_id?.type,
            status: item?.product_id?.status,
            height: item?.product_id?.height,
            weight: item?.product_id?.weight,
            width: item?.product_id?.width,
            longs: item?.product_id?.longs,
            vat: item?.product_id?.vat,
            price: item?.product_id?.price,
            price_import: item?.product_id?.price_import,
            price_wholesale: item?.product_id?.price_wholesale,
            product_id: item?.product_id?.id,
            variant_id: null,
            value: `${item?.id}`,
            label: item?.product_id?.name,
            units: product_variants_units,
            avatar:
              item?.product_id?.product_images &&
              item?.product_id?.product_images[0] &&
              item?.product_id?.product_images[0]?.url,
              batchs: ProductUtil.parseProductBatch(
              item?.product_id?.product_batchs || []
            ),
            stock_quantity: product_stock_lockup,
            product_type: item?.product_id?.product_type
          };
          if (item?.variant_id) {
            const itemVariant = item?.variant_id;
            const product_variants_units: any = ProductUtil.parseProductUnit(
              itemVariant,
              product_variants,
              product_units_lockup
            );
            itemRoot = {
              ...itemRoot,
              name: itemVariant?.name,
              sku: itemVariant?.sku,
              vat: itemVariant?.vat,
              price: item?.price,
              price_import: itemVariant?.price_import,
              price_wholesale: itemVariant?.price_wholesale,
              product_id: item?.id,
              variant_id: itemVariant?.id,
              value: `${item?.id}-${itemVariant?.id}`,
              label: itemVariant?.name,
              units: product_variants_units,
              batchs: ProductUtil.parseProductBatch(
                itemVariant?.product_batchs || []
              ),
            };
          }
          prev = [
            ...prev,
            {
              id: item?.id,
              product_id: item?.product_id?.id,
              variant_id: item?.variant_id?.id,
              fundaccount_id : item?.fundaccount_id,
              product: itemRoot,
              quantity: item?.quantity,
              quantity_request: item?.quantity_request,
              price: item?.price,
              price_request: item?.price_request,
              discount: item?.discount,
              discount_type: item?.discount_type,
              discount_value:
                item?.discount_type === "percent"
                  ? Number(item?.discount_value || 0) * 100
                  : Number(item?.discount_value || 0),
              unit_id: item?.unit_id?.id || 0,
              batch_id: item?.batch_id?.id || 0,
            },
          ];
          return prev;
        },
        []
      );
      const resDataPayment = resData?.orders_payment?.reduce(
        (prev: any, item: any) => {
          prev = [
            ...prev,
            {
              ...item,
              fundaccount_id : item?.fundaccount_id?.id,
              payment_method_id: item?.payment_method_id?.id,
              vnpay_terminal_id: item?.vnpay_terminal_id?.id,
              payment_method: item?.payment_method_id
            },
          ];
          return prev;
        },
        []
      );
      let address_default = resData?.customer_id?.address?.filter((itemFil:any)=> itemFil?.status === 1)
      let shipping_address = ''
      if(address_default?.[0]) {
        address_default = address_default[0]
        shipping_address = address_default?.street || ""
        if(address_default?.wards_code?.name) shipping_address += ", " + address_default?.wards_code?.name
        if(address_default?.district_code?.name) shipping_address += ", " + address_default?.district_code?.name
        if(address_default?.provinces_code?.name) shipping_address += ", " + address_default?.provinces_code?.name
        resData.customer_id.address_default = address_default
      }
      const reason_content = (TextUtils.getLabelByValue(ReasonList, resData?.reason_cancel) || "") +(resData?.reason_content ? (": "+ resData?.reason_content) : '');
      setData({
        ...resData,
        reason_content,
        discount_value:
          resData?.discount_type === "percent"
            ? Number(resData?.discount_value || 0) * 100
            : Number(resData?.discount_value || 0),
        ordersource_id: resData?.ordersource_id?.id,
        shipping_partner_id: resData?.shipping_partner_id?.id,
        shipping_status: (
          resData?.shipping_partner_id?.id 
          || Number(resData?.shipping_fee || 0) > 0
          || data?.desired_time_receive
        ) ? true : false,
        shipping_fee_free:
          Number(resData?.shipping_fee || 0) === 0 ? true : false,
        branch_id: resData?.warehouse_id?.id,
        orderspackage: {
          orderspackage_id: resData?.orderspackage_id?.id,
          servicepackage_id : resData?.service_package_id,
          service_package_id: resData?.service_package_id?.id,
          product_type: resData?.orderspackage_id?.orderspackage_services?.[0]?.product_type,
          discount_order: resData?.service_package_id?.discount_order,
          label: resData?.service_package_id?.name,
          value: resData?.service_package_id?.id,
          type: resData?.service_package_id?.type,
          total_group: resData?.orderspackage_id?.orderspackage_services?.[0]?.total_group || 0,
          total_group_used: resData?.orderspackage_id?.orderspackage_services?.[0]?.total_group_used || 0,
          servicepackage_total: resData?.orderspackage_id?.servicepackage_total || 0,
          code: resData?.service_package_id?.code
        },
      });
      setProduct(resDataProduct);
      setPayment(resDataPayment);
    }
  };

  let STATUS = StatusList
  if(props?.user?.store_id?.is_erp_stock){
      STATUS = StatusList?.filter((item:any)=> item?.value !== 2 && item?.value !== 4)
  }
  
  return (
    <React.Fragment>
      <PageTitle
        breadCrumbItems={[
          {
            label: `${
              type == "view" ? "Chi tiết" : id !== "add" ? "Chỉnh sửa" : "Tạo"
            } đơn online}`,
            active: true,
          },
        ]}
        title={`${
          type == "view" ? "Chi tiết đơn" : id !== "add" ? "Chỉnh sửa đơn online" : "Tạo đơn online"
        }  ${type == "view" ? "#" + data?.code + (data?.erp_order_bso ? ` (${data?.erp_order_bso})` : '') : ''}`}
        subComponent={
          type === "view" &&
          data?.reason_content && (
            <div className="mt-2 text-danger">
              <img
                style={{ border: "none" }}
                src={IconOrderReason}
                width={20}
                height={20}
                alt=""
                className="mr-2"
              />
              <b>Lý do hủy đơn:</b> {data?.reason_content}
            </div>
          )
        }
        rightComponent={
          type === "view" && data?.type ==="online" && (
            <div className="status-step-head float-right mt-1 font-size-14 d-none d-sm-block">
              <div className="sw-main sw-theme-dots">
                <ul className="nav nav-tabs step-anchor">
                  {STATUS?.map((item: any, index: number) => {
                    
                    // const checkActive =
                    //     data?.status === item?.value
                    //     || (Number(item?.value) < Number(data?.status) && Number(item?.value) !== -1)
                    //     || (
                    //         Number(data?.status) === -1 && (Number(item?.value) !== 2 && Number(item?.value) !== 3)
                    //     )
                    const checkActive = data[item?.time]
                      ? true
                      : false || data?.status === item?.value;

                      if( !data[item?.time] && (data?.status == 3 || data?.status == 4 || data?.status == -1)) return null
                     
                    return (
                      <li
                        key={`orrder-step-${index}`}
                        className={`nav-item ${checkActive ? "active" : ""}`}
                      >
                        <a href="javascript:'" className="nav-link">
                          {item?.label}
                          <span>{index + 1}</span>
                          {/* {data?.status === item?.value && <i className="uil uil-check" />} */}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          )
        }
      />
      <ContentPage
        {...props}
        history={history}
        data={data}
        shippingPartner={shippingPartner}
        productTemplate={productTemplate}
        setData={(val: any) => setData(val)}
        onFreshCustomers={loadCustomers}
        customers={customers}
        orderSource={orderSource}
        onlyView={onlyView}
        payment={payment}
        setPayment={setPayment}
        id={id}
        type={type}
        action={action}
        branch_ids ={branch_ids}
        product={product}
        branch={branch}
        setProduct={setProduct}
        handleActionModal={(data: any) => handleActionModal(data)}
        setPaymentSynce={setPaymentSynce}
        loadBranch={(shipping_partner_id:number)=>loadBranch(shipping_partner_id)}
      />
      <ModalPopup isOpen={modalIsOpen} onRequestClose={() => {
        if(action?.onClose){
          action.onClose()
        }
        setIsOpen(false)
      }}>
        {action?.type === "addReceipts" ? (
          <ReceiptsAdd
            closeModal={() => setIsOpen(false)}
            action={action}
            loadData={() => loadData(id)}
            orders_id={action?.orders_id}
          /> 
        ) : (
          <RenderActionModal
            {...props}
            closeModal={() => setIsOpen(false)}
            action={action}
            loadData={() => {
              loadData(id);
              if (type === "view") loadHistory(id);
            }}
            paymentSynce={paymentSynce}
          />
        )}
      </ModalPopup>
      {loading && <Loader />}
    </React.Fragment>
  );
};

const ContentPage = (props: any) => {
  const {
    user,
    onFreshCustomers,
    data,
    type,
    setData,
    customers,
    service,
    orderSource,
    onlyView,
    id,
    payment,
    setPayment,
    action,
    handleActionModal,
    product,
    setProduct,
    setPaymentSynce,
    loadBranch ,
    branch
  } = props;
  const [loading, setLoading] = useState(false);
  const router = useHistory();

  const validationFrom = () => {
    if (!data?.customer_id) {
      toast.warning("Bệnh nhân không được để trống!");
      return false;
    }
    const checkProduct = product?.reduce((prev: any, item: any) => {
      if (
        !item?.product_id ||
        !item?.quantity ||
        (item?.product?.type === "batch" && !item?.batch_id)
      ) {
        prev = false;
      }
      return prev;
    }, true);
    if (!checkProduct) {
      toast.warning("Nhập đầy đủ thông tin sản phẩm");
      return false;
    }
    const paymentCheck = payment?.reduce((prev: any, item: any) => {
      if (
        (item?.payment_method_id && !item?.payment_total) ||
        (!item?.payment_method_id && item?.payment_total)
      ) {
        prev = false;
      }
      return prev;
    }, true);
    if (!paymentCheck) {
      toast.warning("Hình thức hoặc số tiền không được để trống!");
      return false;
    }
    if (data?.shipping_status) {
      //có vận chuyển
      // if (data?.shipping_address_type === "outer") {
      //   if (!data?.shipping_partner_id) {
      //     toast.warning("Đơn vị vận chuyển không được để trống!");
      //     return false;
      //   }
      // }
      if (!data?.shipping_address) {
        toast.warning("Địa chỉ giao hàng không được để trống!");
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async (type?: any) => {
    if (!validationFrom()) return;
    setLoading(true);
    const url = `${baseUrl}/orders`;
    const orders_products = product?.reduce((prev: any, item: any) => {
      prev = [
        ...prev,
        {
          product_id: item?.product_id,
          variant_id: item?.variant_id || undefined,
          quantity: Number(item?.quantity || 0),
          price: Number(item?.price || 0),
          discount_type: item?.discount_type || "price",
          discount_value:
            item?.discount_type === "percent"
              ? Number(item?.discount_value || 0) / 100
              : Number(item?.discount_value || 0),
          unit_id: item?.unit_id ? item?.unit_id : undefined,
          batch_id: item?.batch_id ? item?.batch_id : undefined,
        },
      ];
      return prev;
    }, []);
    const orders_payment = payment?.reduce((prev: any, item: any) => {
      if (item?.payment_total) {
        prev = [
          ...prev,
          {
            id: item?.id || undefined,
            fundaccount_id : item?.fundaccount_id,
            payment_method_id: item?.payment_method_id,
            vnpay_terminal_id: Number(item?.vnpay_terminal_id),
            payment_total: Number(item?.payment_total),
          },
        ];
      }
      return prev;
    }, []);
    const params = {
      order_type: "medicine",
      supplier_id: data?.supplier_id,
      warehouse_id: data?.branch_id,
      branch_id: props.user?.branch_id?.id,
      customer_id: data?.customer_id?.id,
      note: data?.note,
      status: type === "quotation" ? 5 :type === "active" ? 1 : type === "export" ? 2 : 0,
      discount_value:
        data?.discount_type === "percent"
          ? Number(data?.discount_value || 0) / 100
          : Number(data?.discount_value || 0),
      discount_type: data?.discount_type,
      orders_products: orders_products,
      orders_payment: orders_payment?.length > 0 ? orders_payment : undefined,
      shipping_partner_id: data?.shipping_partner_id
        ? Number(data?.shipping_partner_id)
        : undefined,
      shipping_code: data?.shipping_code,
      shipping_fee: Number(data?.shipping_fee || 0),
      shipping_cod: Number(data?.shipping_cod || 0),
      shipping_note: data?.shipping_note,
      ordersource_id: data?.ordersource_id,
      desired_time_receive: moment(data?.desired_time_receive).valueOf(),
      type: "online",
      shipping_address_type: data?.shipping_address_type,
      shipping_address: data?.shipping_address,
      prescription_id: data?.prescription_id || undefined,
      prescription_ids: data?.prescription_ids || [],
      orderspackage_id: data?.orderspackage?.orderspackage_id,
      service_package_id: data?.orderspackage?.service_package_id
    };
    let response: any = await APIClient.POST(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      if (
        response.error?.data &&
        response.error?.data?.statusKey === "updatePrice"
      ) {
        //caajop nhật giá
        props?.handleActionModal({
          type: "updatePrice",
          data: response.error?.data?.data,
          onSubmit: () => {
            const productPrice: any = {};
            response.error?.data?.data?.orders_products?.map((item: any) => {
              productPrice[item?.product_id] = item?.price;
            });
            const orders_products = product?.reduce((prev: any, item: any) => {
              prev = [
                ...prev,
                {
                  ...item,
                  price: productPrice && productPrice[item?.product_id],
                },
              ];
              return prev;
            }, []);
            setProduct(orders_products);
          },
        });
      } else {
        toast.error(response.error.error_description);
      }
    } else if (response.response !== undefined) {
      if(response.response?.payment_sync?.length > 0){
        setPaymentSynce(response?.response?.payment_sync)
        props?.handleActionModal({
          type: "paymentProcess",
          data: response.response,
          onSubmit: () => {
            toast.success("Tạo mới đơn online thành công");
            router?.push(`/order/${response?.response?.id}/view`);
          },
          onClose: () => {
            toast.success("Tạo mới đơn online thành công");
            router?.push(`/order/${response?.response?.id}/view`);
          },
        });
      }else{
        toast.success("Tạo mới đơn online thành công");
        router?.push(`/order/${response?.response?.id}/view`);
      }
     
    }
  };

  const handleEdit = async () => {
    if (!validationFrom()) return;
    setLoading(true);
    const url = `${baseUrl}/orders/${id}`;
    const orders_products = product?.reduce((prev: any, item: any) => {
      prev = [
        ...prev,
        {
          id: item?.id,
          product_id: item?.product_id,          
          variant_id: item?.variant_id || undefined,
          quantity: Number(item?.quantity || 0),
          price: Number(item?.price || 0),
          discount_type: item?.discount_type || "price",
          discount_value:
            item?.discount_type === "percent"
              ? Number(item?.discount_value || 0) / 100
              : Number(item?.discount_value || 0),
          unit_id: item?.unit_id ? item?.unit_id : undefined,
          batch_id: item?.batch_id ? item?.batch_id : undefined,
        },
      ];
      return prev;
      
    }, []);
    const orders_payment = payment?.reduce((prev: any, item: any) => {
      if (item?.payment_total) {
        prev = [
          ...prev,
          {
            id: item?.id || undefined,
            fundaccount_id : item?.fundaccount_id ,
            payment_method_id: item?.payment_method_id,
            payment_total: Number(item?.payment_total),
          },
        ];
      }
      return prev;
    }, []);
    const params = {
      order_type: "medicine",
      supplier_id: data?.supplier_id,
      warehouse_id: data?.branch_id,
      branch_id: props.user?.branch_id?.id,
      customer_id: data?.customer_id?.id,
      note: data?.note,
      status: 0,
      discount_value:
        data?.discount_type === "percent"
          ? Number(data?.discount_value || 0) / 100
          : Number(data?.discount_value || 0),
      discount_type: data?.discount_type,
      orders_products: orders_products,
      orders_payment: orders_payment?.length > 0 ? orders_payment : undefined,
      shipping_partner_id: data?.shipping_partner_id
        ? Number(data?.shipping_partner_id)
        : undefined,
      shipping_code: data?.shipping_code,
      shipping_fee: Number(data?.shipping_fee || 0),
      shipping_cod: Number(data?.shipping_cod || 0),
      shipping_note: data?.shipping_note,
      ordersource_id: data?.ordersource_id,
      desired_time_receive: moment(data?.desired_time_receive).valueOf(),
      type: "online",
      shipping_address_type: data?.shipping_address_type,
      shipping_address: data?.shipping_address,
      prescription_id: data?.prescription_id || undefined,
      orderspackage_id: data?.orderspackage?.orderspackage_id,
      service_package_id: data?.orderspackage?.service_package_id
    };
    let response: any = await APIClient.PUT(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      if (
        response.error?.data &&
        response.error?.data?.statusKey === "updatePrice"
      ) {
        //caajop nhật giá
        props?.handleActionModal({
          type: "updatePrice",
          data: response.error?.data?.data,
          onSubmit: () => {
            const productPrice: any = {};
            response.error?.data?.data?.orders_products?.map((item: any) => {
              productPrice[item?.product_id] = item?.price;
            });
            const orders_products = product?.reduce((prev: any, item: any) => {
              prev = [
                ...prev,
                {
                  ...item,
                  price: productPrice && productPrice[item?.product_id],
                },
              ];
              return prev;
            }, []);
            setProduct(orders_products);
          },
        });
      } else {
        toast.error(response.error.error_description);
      }
    } else if (response.response !== undefined) {
      if(response.response?.payment_sync?.length > 0){
        setPaymentSynce(response?.response?.payment_sync)
        props?.handleActionModal({
          type: "paymentProcess",
          data: response.response,
          onSubmit: () => {
            toast.success("Chỉnh sửa đơn online thành công");
            router?.push(`/order/${response?.response?.id}/view`);
          },
          onClose: () => {
            toast.success("Chỉnh sửa đơn online thành công");
            router?.push(`/order/${response?.response?.id}/view`);
          },
        });
      }else{
        toast.success("Chỉnh sửa đơn online thành công");
        router?.push(`/order/${response?.response?.id}/view`);
      }
      
    }
  };
  
  return (
    <PageContent className={onlyView ? "only-view" : ""}>
      <Row>
        <Col md={8} xs={12}>
          <Row>
            <Col md={6} xs={12}>
              <OrderAddCustomer {...props} />
            </Col>
            <Col md={6} xs={12}>
              <OrderAddInfo {...props} />
            </Col>
            <Col md={12}>
              <OrderAddProduct {...props} />
            </Col>
          </Row>
        </Col>
        <Col md={4} xs={12}>
          <OrderAddPayment {...props}  />
          <OrderAddShip {...props} loadBranch={(shipping_partner_id:number)=>loadBranch(shipping_partner_id)}  />
          {type === "view" && <OrderAddHistory {...props} />}
        </Col>
      </Row>
      <div className="bottom-action">
        <Button
          color="dark"
          className="dark-bland ml-2"
          onClick={() => router?.goBack()}
        >
          Đóng
        </Button>
        {id === "add" && (
          <>
            {!user?.store_id?.is_erp_stock && 
            <>
            <Button
              color="success"
              className="success-bland ml-2"
              onClick={() =>
                props?.handleActionModal({
                  type: "activeConfirm",
                  data: data,
                  onSubmit: () => handleSubmit("active"),
                })
              }
            >
              Xác nhận
            </Button>
            <Button
              color="primary"
              className="ml-2"
              onClick={() =>
                props?.handleActionModal({
                  type: "exportConfirm",
                  data: data,
                  onSubmit: () => handleSubmit("export"),
                })
              }
            >
              Xuất kho
            </Button>
            </>
            }
            <Button
              color="success"
              className="success-bland ml-2"
              onClick={() =>
                props?.handleActionModal({
                  type: "activeConfirm",
                  data: data,
                  onSubmit: () => handleSubmit("active"),
                })
              }
            >
              Xác nhận
            </Button>
            <Button color="success" className="ml-2" onClick={handleSubmit}>
              Lưu
            </Button>
          </>
        )}
        {id && type == "view" && (
          <>
            {data?.status !== 0 &&
              data?.status !== -1 &&
              data?.payment_status !== "paid" && (
                <Button
                  onClick={() =>
                    props?.handleActionModal({
                      type: "addReceipts",
                      data: {},
                      orders_id: data?.id,
                    })
                  }
                  color="info"
                  className="ml-2"
                >
                  Thanh toán
                </Button>
              )}
            {data?.status == 0 && (
              <>
                <Button
                  color="success"
                  className="success-bland ml-2"
                  onClick={() =>
                    props?.handleActionModal({ type: "active", data: data })
                  }
                >
                  Xác nhận
                </Button>
                {!user?.store_id?.is_erp_stock && <>
                <Button
                  color="success"
                  className="success-bland ml-2"
                  onClick={() =>
                    props?.handleActionModal({ type: "active", data: data })
                  }
                >
                  Xác nhận
                </Button>
                <Button
                  color="primary"
                  className="ml-2"
                  onClick={() =>
                    props?.handleActionModal({ type: "export", data: data })
                  }
                >
                  Xuất kho
                </Button></>}
                <Button
                  color="success"
                  className="ml-2"
                  onClick={() => router?.push(`/order/${id}`)}
                >
                  Chỉnh sửa
                </Button>
                <Button
                  color="dangger"
                  className="danger-bland ml-2"
                  onClick={() =>
                    props?.handleActionModal({ type: "reject", data: data })
                  }
                >
                  Hủy
                </Button>
              </>
            )}
            {data?.status == 1 && (
              <>
                {!user?.store_id?.is_erp_stock && <Button
                  color="info"
                  className="ml-2"
                  onClick={() =>
                    props?.handleActionModal({ type: "export", data: data })
                  }
                >
                  Xuất kho
                </Button>}
                {/* <Button color="warning" className='ml-2' onClick={() => props?.handleActionModal({type: 'return', data: data})}>Chuyển hoàn</Button> */}
                <Button
                  color="dangger"
                  className="danger-bland ml-2"
                  onClick={() =>
                    props?.handleActionModal({ type: "reject", data: data })
                  }
                >
                  Hủy
                </Button>
              </>
            )}
            {data?.status == 2 && (
              <>
                {!user?.store_id?.is_erp_stock && <Button
                  color="warning"
                  className="ml-2"
                  onClick={() =>
                    props?.handleActionModal({ type: "return", data: data })
                  }
                >
                  Chuyển hoàn
                </Button>}
                <Button
                  color="info"
                  className="ml-2"
                  onClick={() =>
                    props?.handleActionModal({ type: "done", data: data })
                  }
                >
                  Hoàn thành
                </Button>
              </>
            )}
            {data?.status == 5 && (
              <>
                {!user?.store_id?.is_erp_stock && <>
                <Button
                  color="success"
                  className="success-bland ml-2"
                  onClick={() =>
                    props?.handleActionModal({ type: "active", data: data })
                  }
                >
                  Xác nhận
                </Button>
              </>}
                {/* <Button color="warning" className='ml-2' onClick={() => props?.handleActionModal({type: 'return', data: data})}>Chuyển hoàn</Button> */}
                <Button
                  color="dangger"
                  className="danger-bland ml-2"
                  onClick={() =>
                    props?.handleActionModal({ type: "reject", data: data })
                  }
                >
                  Hủy
                </Button>
              </>
            )}
          </>
        )}
        {id !== "add" && type != "view" && (
          <Button color="success" className="ml-2" onClick={handleEdit}>
            Lưu lại
          </Button>
        )}
      </div>
      {loading && <Loader />}
    </PageContent>
  );
};

const mapState = (state: any) => {
  return {
    user: state.Auth.user,
  };
};

const PageContent = styled.div`
  padding-bottom: 70px;
  &.only-view {
    .nutri-form {
      input {
        border: none;
        pointer-events: none;
      }
      .react-select__indicators {
        display: none !important;
      }
      .react-select__control {
        border: none;
        background-color: transparent !important;
      }
    }
  }
`;

export default connect(mapState, { changeSidebarType })(Detail);
